const List = () => import('./main.vue');

export default [
  {
    name: 'processo-movimento',
    path: '/processo-movimento',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Processo Movimento RPS',
      icon: 'edit',
      can: 'insert',
      on: 'movimentorps',
    },
  },
];
